import * as qrImage from 'qr-image';

export function qrEncode(text) {
    const options = {ec_level: 'L', size: 4, margin: 5};
    const buffer = qrImage.imageSync(text, options);
    const base64 = buffer.toString('base64');
    return `data:image/png;base64,${base64}`;
}



// WEBPACK FOOTER //
// ./src/modules/reverse-ajax/sp-qr/qr-encode.js